

import axios from "axios";

import { responseSuccessInterceptor, responseErrorInterceptor } from './interceptors';
import environment from "../environment";

const BaseApi = axios.create({
    baseURL: environment.api,
    // baseURL: "http://192.168.1.11:5001/",
});

BaseApi.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default BaseApi;